<template>
    <form-modal
        :open="isAddModalOpen"
        :heading="$t('modals.recurringBill.add')"
        entity="recurringBill"
        mode="add"
        :submit-label="$t('modals.recurringBill.save')"
        :fields="fields"
        save-url="/add-recurring-bill.php"
        :build-payload="buildPayload"
        @update:open="$emit('update:isAddModalOpen', $event)"
        @opened="fetchSubcategories"
        @saved="$emit('bill-saved')"
    />
</template>

<script>
import { computed } from 'vue';
import { useSubcategoryOptions } from '@/composables/useSubcategoryOptions';
import FormModal from '@/components/common/FormModal.vue';
import { t } from '@/i18n';

export default {
    components: {
        FormModal,
    },
    props: {
        isAddModalOpen: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['update:isAddModalOpen', 'bill-saved'],
    setup() {
        const { subcategoryGroups, fetchSubcategories } = useSubcategoryOptions();

        const fields = computed(() => [
            { key: 'subcategory_id', label: t('fields.subcategory'), type: 'select', required: true, placeholder: t('placeholders.selectSubcategory'), groups: subcategoryGroups.value },
            {
                key: 'day', label: t('fields.dayOfMonth'), type: 'number', required: true, min: 1, max: 31, digitsOnly: true,
                hint: t('hints.billDay')
            },
            { key: 'value', label: t('fields.value'), type: 'number', required: true },
            { key: 'name', label: t('fields.name'), type: 'text', required: true },
        ]);

        const buildPayload = (form) => ({
            subcat: form.subcategory_id,
            day: form.day,
            value: form.value,
            name: form.name,
        });

        return { fields, fetchSubcategories, buildPayload };
    },
};
</script>
